import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { BillingPath } from 'entities/ExportRouters'
import styles from 'widgets/Sidebar/ui/MainDropdown/styles.module.scss'

type IUpgradeSubscriptionBtnProps = {
  onClick?: () => void
}

export const UpgradeSubscriptionBtn: FC<IUpgradeSubscriptionBtnProps> = observer(({ onClick }) => {
  const { subscriptionStore, organizationStore, usersStore, featureFlagsStore } =
    useEntitiesContext()
  const isUpgradeDisabled =
    !subscriptionStore.subscriptionSuggestion &&
    (!!subscriptionStore.plan?.custom || organizationStore.is_contract)

  if (!usersStore.user?.isAdminOrOwnerRole) return null

  return (
    <div
      className={styles.blockWrapper}
      aria-label={getAriaLabel('UpgradeSubscriptionBtn')}
      onClick={() => {
        onClick?.()
      }}
    >
      {isUpgradeDisabled ? (
        <Button
          id='intercom-custom-plan_sidebar-button'
          text='Upgrade'
          intent='positive'
          fullWidth
        />
      ) : (
        <Button
          text='Upgrade'
          intent='positive'
          fullWidth
          onClick={() => {
            if (subscriptionStore.subscriptionSuggestion) {
              uiStore.changeRouteViaVue({
                path: featureFlagsStore.billing_overview_v2
                  ? `/${BillingPath.overview}`
                  : `/${BillingPath.upgrade}`,
                options: {
                  state: {
                    checkOpportunity: true,
                  },
                },
              })
            } else {
              uiStore.changeRouteViaVue({
                path: `/${BillingPath.upgrade}`,
              })
            }
          }}
        />
      )}
    </div>
  )
})
